import ComponentConfig from '../classes/component-config';
import { toast } from '../../utils';
import { Toast } from '@ks/sharp-ui';
import { formatters } from './formatters';
import lodashGet from 'lodash/get';
import formEventBus, { FORM_EVENTS_TYPE } from '../../utils/event-bus';
/**
 * 🏗 todo: 修改注释，渲染部分的逻辑已被重写
 * config格式&wiki
 * https://wiki.corp.kuaishou.com/pages/viewpage.action?pageId=102786580
 */
import { component } from './props';
import { component as DatetimePickerComponent } from '../mobile-general-form-datetime-picker/props';

const validityPeriod = -1; // 有效期永久

export default {
    name: component,
    props: {
        // 配置数据改为直接传入
        originConfig: {
            type: Object,
            required: true,
        },
        /**
         * 父级组件的输出路径
         * 复制器组件中的排序会改变组件的输出路径
         * 因此需要记录父组件的输出路径来确定当前组件的输出路径
         * 并且确定子组件的输出路径
         */
        parentOutputPath: {
            type: String,
            required: true,
        },
    },
    inject: {
        // 注入表单根元素
        formRoot: {
            from: 'formRoot',
            default: () => ({}),
        },
    },
    created() {
        this.$toast = toast;
    },
    data() {
        return {
            config: new ComponentConfig(this.originConfig),
            depHandlers: [],
            ready: false,
            updateDisabled: false,
            showRejectTip: true,
        };
    },
    watch: {
        originConfig: {
            handler(newConfig) {
                this.config = new ComponentConfig(newConfig);
                this.configChangeHandler(newConfig);
            },
        },
        'config.uuid': {
            immediate: true,
            handler(newUuid, oldUuid) {
                // console.log(`[${newUuid}] uuid watch`);
                this.globalModel.registerComponent({
                    id: newUuid,
                    vm: this,
                });
                if (oldUuid && newUuid !== oldUuid) {
                    this.globalModel.deregisterComponent({
                        id: oldUuid,
                        vm: this,
                    });
                }
            },
        },
        'config.deps': {
            handler(newDeps, oldDeps) {
                // console.log(`[${this.uuid}] deps watch`);
                this.removeDeps(oldDeps);
                this.addDeps(newDeps);
            },
        },
        selfDisabled: {
            immediate: true,
            handler: 'selfDisabledChangeHandler',
        },
        'globalModel.formData': {
            deep: true,
            handler(data) {
                // console.log(`[${this.uuid}] formData watch`);
                this.dataChangeHandler(data);
            },
        },
    },
    computed: {
        // 组件id
        uuid() {
            return this.config.uuid;
        },
        // 组件配置
        props() {
            return this.config.props || {};
        },
        // ocr内容配置
        ocrConfig() {
            return this.config.props.ocrConfig || {};
        },
        // 表单属性
        bindFormAttributes() {
            return this.formRoot.mixedFormAttributes;
        },
        // 自身是否被禁用有同时被全局禁用和自身禁用控制
        // tips：非驳回字段不支持修改没法直接复用selfDisabled。。因为会导致skipValidate。。鬼逻辑。。
        selfDisabled() {
            return !!this.bindFormAttributes.disabled || !!this.config.props.disabled;
        },
        // 全局模型通过根元素引入
        globalModel() {
            return this.formRoot.globalModel;
        },
        // 不支持修改
        notChanged() {
            return this.notRejectFields || this.selfDisabled;
        },
        // 非驳回字段 禁止修改
        notRejectFields() {
            return this.globalModel.fieldReview
                && !this.hasRejectTip
                && !this.updateDisabled
                && this.originConfig.component !== 'mobile-general-form-button';
        },
        // 存在字段驳回提示
        hasRejectTip() {
            const hasError = this.outputError(this.config.label);
            if (hasError) {
                return true;
            }
            return false;
        },
        // 根据parentOutputPath属性和自身配置计算出输出值的路径
        outputPath() {
            const pathArray = [this.parentOutputPath, this.config.output].filter(path => path);
            return pathArray.join('.');
        },
        // 提供国际化过的label供各组件直接调用，其他文案可调用i18n方法
        i18nLabel() {
            return this.i18n(this.config.label);
        },
    },
    methods: {
        /**
         * interface 基本组件需要自行实现
         * 用于处理config字段的变化
         * @param {*} config
         */
        configChangeHandler(config) {
            // do nothing
            return config;
        },
        lastShowRejectTip(i18nLabel) {
            return this.globalModel.fieldReview && this.hasRejectTip && this.showRejectTip && !this.isChanged(i18nLabel);
        },
        onClickForm() {
            if (this.notChanged) {
                this.selfDisabled ? toast('该输入框被禁用，暂不支持上传') : toast('信息填写正确，无需修改');
                return false;
            }
            return true;
        },
        outputError(i18nLabel) {
            let isErrorItem = '';
            this.globalModel.errorData && this.globalModel.errorData.forEach(v => {
                const res = v.outputList.find(i => i.label === i18nLabel);
                if (res) {
                    isErrorItem = v.mark;
                }
            });
            return isErrorItem;
        },
        isChanged(i18nLabel) {
            let isChanged = false;
            this.globalModel.errorData && this.globalModel.errorData.forEach(v => {
                const res = v.outputList.find(i => i.label === i18nLabel);
                if (res) {
                    isChanged = res.isChanged;
                }
            });
            return isChanged;
        },
        // 更新被驳回导致的禁用状态
        updateDisabledStatus(disabled) {
            this.updateDisabled = disabled;
        },
        // 更新展示驳回字段
        updateRejectTipShow(showRejectTip) {
            this.showRejectTip = showRejectTip;
        },
        /**
         * interface 基本组件需要自行实现
         * 用于处理全局数据的变化
         * 注意，各个组件在处理后需要自行抛出依赖监听的change事件
         * @param {*} data
         */
        dataChangeHandler(data) {
            // do nothing
            return data;
        },
        /**
         * interface 基本组件需要自行实现
         * 用于验证组件输入
         */
        validate() {
            // do nothing
            return true;
        },
        /**
         * interface 基本组件需要自行实现
         * 清除验证状态
         */
        clearValidate() {
            // do nothing
        },

        // 以下是已实现的公共方法

        // 校验失败报错
        validateFailureHandler(msg) {
            // this.$toast.error(msg);
            // 当锚定到第一个校验错误表单项时，其他错误的不用再锚定了
            // console.log('[zy] ', !this.$el, this.formRoot.isAnchored);
            if (!this.$el || this.formRoot.isAnchored) {
                return;
            }
            this.$el.scrollIntoViewIfNeeded && this.$el.scrollIntoViewIfNeeded() || this.$el.scrollIntoView({ block: 'center' });
            this.formRoot.isAnchored = true;
        },

        // toast & log
        toastAndLog(msg, isSendLog = true) {
            Toast.info(msg);
            if (isSendLog) {
                formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'SHOW', 'VERIFY_ERROR_TIPS', {
                    tips_content: msg,
                });
            }
        },

        // 异常输出
        warn(msg) {
            if (typeof msg === 'string') {
                console.warn(`[${this.uuid}]${msg}`);
            } else {
                console.warn(msg);
                console.warn(`catched in [${this.uuid}]`);
            }
        },

        // 判断是否跳过校验的公共方法
        skipValidate() {
            return !this.ready // 初始化前不校验
                || !!this.config.props.hide // 隐藏掉的不校验
                || !!this.selfDisabled; // 被禁用的不校验
        },

        selfDisabledChangeHandler(val) {
            this.$nextTick(() => {
                if (val) {
                    // this.clearValidate();
                } else {
                    // this.validate();
                }
            });
        },

        /**
         * 根据路径获取对应全局数据值的公共方法
         * @param {*} path 输出路径
         */
        getFormDataValueByPath(path = '') {
            return this.globalModel.getFormDataValueByPath(path);
        },
        getValueById(id, path) {
            return this.globalModel.getValueById(id, path);
        },
        /**
         * 根据路径设置对应全局数据值的公共方法
         * @param {*} value 需要提交的值
         * @param {*} path 输出路径
         */
        setFormDataValueByPath(value, path = '') {
            return this.globalModel.setFormDataValueByPath(path, value);
        },
        /**
         * 获取自身件对应的全局数据值的公共方法
         * @param {*} subPath 对应子路径
         */
        getSelfFormDataValue(subPath = '') {
            return this.globalModel.getFormDataValueByPath(this.outputPath + (subPath || ''));
        },
        /**
         * 提交值改动到组件对应的全局数据的公共方法
         * @param {*} value 需要提交的值
         * @param {*} subPath 输出子路径
         */
        setSelfFormDataValue(value, subPath = '') {
            return this.globalModel.setFormDataValueByPath(this.outputPath + (subPath || ''), value);
        },
        // 移除依赖
        removeDeps(deps) {
            if (!deps || deps.length === 0) {
                return;
            }
            // console.log(`[${this.uuid}] removeDeps`);
            deps.forEach((dep, depIndex) => {
                if (dep.listen
                    && this.globalModel.componentModels[dep.listen]) {
                    this.globalModel.componentModels[dep.listen].$off(
                        dep.event,
                        this.depHandlers[depIndex]
                    );
                    this.depHandlers[depIndex] = null;
                } else {
                    this.warn(`Invalid dependency for ${this.uuid}, deregister failed.`);
                }
            });
        },
        // 添加依赖
        addDeps(deps) {
            if (!deps || deps.length === 0) {
                return;
            }
            // console.log(`[${this.uuid}] addDeps`);
            for (const depIndex in deps) {
                const depInfo = deps[depIndex];
                if (depInfo.listen && this.globalModel.componentModels[depInfo.listen]) {
                    const handler = (
                        (depInfo, self) =>
                            () => self.depHandler.bind(self)(depInfo)
                    )(depInfo, this);
                    this.depHandlers[depIndex] = handler;
                    this.globalModel.componentModels[depInfo.listen].$on(
                        depInfo.event,
                        handler
                    );
                } else {
                    this.warn(`Invalid dependency for ${this.uuid}, register failed.`);
                }
            }
        },
        // 触发依赖时的处理
        async depHandler(depInfo) {
            let result;

            // 先判断有没有formatter
            // 由于formatter有分级，depInfo.formatter.name需要是长度至少为2的数组
            if (depInfo.formatter
                    && Array.isArray(depInfo.formatter.name)
                    && depInfo.formatter.name.length > 1
            ) {
                const selectedFormatter = lodashGet(
                    formatters,
                    depInfo.formatter.name.join('.')
                );
                if (selectedFormatter) {
                    const args = this.globalModel.getValueById(depInfo.listen, depInfo.source);

                    let extraArgs = [];
                    if (typeof depInfo.formatter.extra === 'string' && depInfo.formatter.extra) {
                        // extra字段不为空则将其作为JSON解析
                        try {
                            extraArgs = JSON.parse(depInfo.formatter.extra);
                        } catch (e) {
                            this.warn(e);
                        }
                    }
                    if (['trick'].includes(depInfo.formatter.name[0])) {
                        // 新开了一类formatter类别 trick  函数运行时提供this
                        const contextedFn = selectedFormatter.fn.bind(this);
                        result = contextedFn(args, ...extraArgs);
                    } else {
                        result = selectedFormatter.fn(args, ...extraArgs);
                    }
                } else {
                    // TODO 自定义formatter的处理
                }
            } else {
                // 不存在，source直接输出到destination
                result = this.globalModel.getValueById(depInfo.listen, depInfo.source);
            }

            // 输出结果
            try {
                const destination = depInfo.destination;
                if (destination === 'value') {
                    if (this.config.component === 'mobile-general-form-input') {
                        // 输入框联动赋值为空，需要额外处理下，不给赋值为空
                        result && this.setSelfFormDataValue(result);
                    } else {
                        // 输出到组件对应的值
                        this.setSelfFormDataValue(result);
                    }
                } else {
                    // 输出到对应的props
                    this.globalModel.setConfigPropsValueByPath(
                        this.config,
                        destination,
                        result
                    );
                    if (destination === 'hide' && result) {
                        // 如果是mobile-general-form-order组件，则设置为undefined
                        // 如果是null类型的组件，则设置为null （有一个组件list）
                        const isOrderComponent = this.config.component === 'mobile-general-form-order';
                        const nullComponentList = ['mobile-general-form-city-picker', 'mobile-general-form-datetime-picker',
                            'mobile-general-form-single-upload'];
                        const isNullComponent = nullComponentList.includes(this.config.component);
                        if (isOrderComponent) {
                            this.setSelfFormDataValue(undefined);
                        } else if (isNullComponent) {
                            this.setSelfFormDataValue(null);
                        } else {
                            this.setSelfFormDataValue('');
                        }
                    }
                    if (destination === 'hide' && !result) {
                        this.globalModel.fieldReview && this.updateDisabledStatus(true);
                    }
                }
            } catch (e) {
                this.warn(e);
            }
        },
        // 生成使用api校验规则的公共方法
        composeApiRule(validatorId) {
            return async (rule, value = '', callback) => {
                if (value === '' || value === null || this.skipValidate()) {
                    return callback();
                }

                const apiModel = this.globalModel.componentModels[validatorId];
                try {
                    const { valid, msg } = await apiModel.trigger();
                    if (valid) {
                        return callback();
                    }
                    const newMsg = this.i18n(msg || this.props.errValidator || '网络错误');
                    return callback(new Error(newMsg));
                } catch (e) {
                    return callback(new Error(e && e.message));
                }
            };
        },
        // 生成一般校验规则的公共方法
        composeRules(props, conf = {}) {
            // console.log(`[${this.uuid}] composeRules`);
            const { otherRules = [] } = conf;
            const rules = [];
            // 先校验是否必填
            rules.push({
                required: !!props.required,
                message: this.i18n(this.props.errRequired, this.i18nLabel) || `${this.i18nLabel}不能为空`,
            });
            // 远程校验方法
            if (props.validator) {
                rules.push({
                    validator: this.composeApiRule(props.validator),
                });
            }
            rules.push(...otherRules);
            return rules;
        },
        // label等字段兼容code和直接输出文案模式
        i18n(code, ...args) {
            if (this.formRoot.i18nMethod) {
                return this.formRoot.i18nMethod(code, ...args) || code;
            }
            return code;
        },
        // 埋点方法调用传入的外部方法
        logger(action, params) {
            if (this.formRoot.loggerMethod) {
                this.formRoot.loggerMethod({
                    uuid: this.config.uuid,
                    component: this.config.component,
                    output: this.config.output,
                    // 暂时开放上面三个config字段给业务判断具体组件
                    // 表单组件动作
                    action,
                    // 表单组件埋点相关数据（各组件自定）
                    params, // 可能是undefined
                });
            }
        },
        showDialog(uid) {
            uid && this.globalModel.componentModels[uid].show();
        },
        dealDatePicker(ocrResult) {
            // 如果不是永久 并且有值 则直接更新Time
            console.log('[hal]', ocrResult);
            if (ocrResult[this.ocrConfig.ocrKey] !== validityPeriod) {
                ocrResult[this.ocrConfig.ocrKey] && this.setSelfFormDataValue(ocrResult[this.ocrConfig.ocrKey]);
                return;
            }
            // 下面是有效期永久的逻辑
            let time = this.props.maxDateTimestamp || '';
            // 这种情况获取到时间选择器的【最大可选时间戳】默认undefined是10年
            if (!this.props.maxDateTimestamp) {
                const curDate = new Date();
                // 获取当前年份并加10年
                const futureYear = curDate.getFullYear() + 10;
                // 创建未来的日期对象，设定为12月31日00分00秒
                const futureDate = new Date(futureYear, 11, 31, 0, 0, 0);
                time = futureDate.getTime();
            }
            this.setSelfFormDataValue(time);
        },
        dealOcrRecognition(data) {
            try {
                // 首先判断listen是否一致、抛出的listen是否有值
                const { listen = '', ocrResult = {} } = data;
                if (!listen || listen !== this.ocrConfig.listen) {
                    return;
                }
                const result = ocrResult[this.ocrConfig.ocrKey] || '';
                const isDatePicker = this.config.component === DatetimePickerComponent;
                // 判断识别的key以及识别结果 除非是时间选择器（存在识别成永久的情况）
                if (ocrResult && this.ocrConfig.ocrKey && (result || isDatePicker)) {
                    // destination是个数组 可以绑定value或者placeholder
                    this.ocrConfig.destination.forEach(key => {
                        if (key === 'value') {
                            // 如果是时间选择器
                            isDatePicker ? this.dealDatePicker(ocrResult) : this.setSelfFormDataValue(result);
                        } else {
                            // 需要判断是否有占位符$ placeholder中变量通过占位符
                            const curValue = this.globalModel.getConfigPropsValueByPath(this.config, key);
                            if (curValue && curValue.indexOf('$') > -1) {
                                const newValue = curValue.replace('$', result);
                                // 输出到对应的props
                                this.globalModel.setConfigPropsValueByPath(
                                    this.config,
                                    key,
                                    newValue
                                );
                            }
                        }
                    });
                }
                console.log('[hal]: ocr', data, this.ocrConfig);
            } catch (e) {
                console.log('识别error', e);
            }
        },
        handlerOcr() {
            formEventBus.$on(FORM_EVENTS_TYPE.OCR_RECOGNITION, this.dealOcrRecognition);
        },
    },
    mounted() {
        // console.log(`[${this.uuid}] mounted`);
        this.addDeps(this.config.deps);
        // 判断是否绑定ocr，如果绑定监听事件
        this.ocrConfig.listen && this.handlerOcr();
        this.$nextTick(() => {
            // 调用一次dataChangeHandler以获取初始数据
            this.dataChangeHandler();
            // 抛出ready事件
            this.$emit('ready');
            this.ready = true;
        });
    },
    updated() {
        // 这里还需要判断下updated是否在beforeDestroy之后触发的
        if (!this.globalModel.componentModels[this.uuid]) {
            return;
        }
        // 抛出updated事件
        this.$emit('updated');
        // 抛出all-updated事件
        this.$nextTick(() => {
            this.$emit('all-updated');
        });
        // 监听每一个组件的change事件
        this.$on('change', () => {
            this.globalModel.fieldReview && this.updateRejectTipShow(false);
        });
    },
    beforeDestroy() {
        this.ocrConfig.listen && formEventBus.$off(FORM_EVENTS_TYPE.OCR_RECOGNITION, this.dealOcrRecognition);
        // console.log(`[${this.uuid}] beforeDestroy`);
        // 移除注册
        this.globalModel.deregisterComponent(this.uuid);
        // console.log(`[${this.uuid}] deregistered`);
    },
    destroyed() {
        // console.log(`[${this.uuid}] destroyed`);
    },
};
